<template>
  <div class="flex flex-wrap mt-4">
    <div class="w-full mb-12 px-4">
      <card-record
        title="Obra"
        resource="obras"
        primaryKey="idobra"
        :record="record"
        :columns="columns"
        @saveChanges="handleSave"
        :service="service"
      />
    </div>
    <div class="w-full mb-12 px-4" v-if="!isNew">
      <card-list
        title="Presupuestos"
        resource="proyectos"
        primaryKey="idpresupuesto"
        :records="proyectos"
        :meta="proyectosMeta"
        :columns="proyectosColumns"
        :readonly="proyectosReadonly"
      >
        <template v-slot:after-table>
          <totales-proyectos :meta="proyectosMeta" />
        </template>
      </card-list>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import CardList from "@/components/Cards/CardList.vue";
import CardRecord from "@/components/Cards/CardRecord.vue";
import TotalesProyectos from "@/components/Cards/TotalesProyectos.vue";
import ObraService from "@/services/obra.service";
import PresupuestoService from "@/services/presupuesto.service";
import { obra } from "@/models/obra";
import { presupuesto } from "@/models/presupuesto";

export default {
  components: {
    CardList,
    CardRecord,
    TotalesProyectos,
  },

  data() {
    return {
      record: {},
      columns: obra,
      service: ObraService,
      proyectos: {},
      proyectosMeta: {},
      proyectosColumns: presupuesto.filter(
        (column) => column.showOnList && column.name !== "idobra"
      ),
    };
  },

  watch: {
    $route: {
      immediate: true,
      handler(/*to, from*/) {
        const params = this.$route.query;
        const presupuestoFilters = JSON.parse(params.filters || "{}");
        presupuestoFilters.idobra = { value: this.idobra, type: "obra" };
        params.filters = JSON.stringify(presupuestoFilters);

        ObraService.get(this.idobra)
          .then((data) => {
            this.record = data.record;
          })
          .catch((response) => {
            console.log(response);
          });

        PresupuestoService.list(params)
          .then((data) => {
            this.proyectos = data.records;
            this.proyectosMeta = data.meta;
          })
          .catch((response) => {
            console.log(response);
          });
      },
    },
  },

  computed: {
    ...mapState({
      userInfo: (state) => state.auth.user,
    }),

    idobra() {
      return this.$route.params.id;
    },

    isNew() {
      return this.idobra == "new";
    },

    proyectosReadonly() {
      const roles = this.userInfo?.roles || [];
      return !roles.includes("admin") && !roles.includes("personal");
    },
  },

  methods: {
    handleSave(record) {
      this.record = record;
    },
  },
};
</script>
